export function sortRecords(records: Array<{ type: string }>) {
  return records.sort((a: any, b: any) => {
    const typePriority = {
      domain: 1,
      configuration: 2,
      application: 3,
      schema: 4,
    };

    return (
      typePriority[a.type as keyof typeof typePriority] -
      typePriority[b.type as keyof typeof typePriority]
    );
  });
}
